module.exports = __webpack_public_path__ + "img/map_1791458180264_66000.10d0894d.jpg";